const question = {
    highlyImportant: { values: ['P'], rejectedProfiles: ['D'] },
    important: { values: ['E'] },
    notImportant: { values: ['D'] },
};

export default question;
